import { makeAutoObservable, runInAction } from 'mobx';
import { pluginService } from '../services/pluginService';
import { Plugin } from '../types/Plugin';

export class PluginStore {
  plugins: Plugin[] = [];
  activePlugins: Plugin[] = [];
  isLoading = false;
  error: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setError(error: string | null) {
    this.error = error;
  }

  setLoading(loading: boolean) {
    this.isLoading = loading;
  }

  async fetchActivePlugins() {
    this.setLoading(true);
    this.setError(null);

    try {
      const response = await pluginService.getActivePlugins();
      
      runInAction(() => {
        this.activePlugins = response.plugins;
        this.plugins = response.plugins;
      });

      return { success: true };
    } catch (error: any) {
      runInAction(() => {
        this.error = error.message;
      });
      return { success: false, error: error.message };
    } finally {
      this.setLoading(false);
    }
  }

  async fetchAllPlugins() {
    this.setLoading(true);
    this.setError(null);

    try {
      const response = await pluginService.getPlugins();
      
      runInAction(() => {
        this.plugins = response.plugins;
        this.activePlugins = response.plugins.filter(p => p.status === 'active');
      });

      return { success: true };
    } catch (error: any) {
      runInAction(() => {
        this.error = error.message;
      });
      return { success: false, error: error.message };
    } finally {
      this.setLoading(false);
    }
  }

  getPluginById(id: string): Plugin | undefined {
    return this.plugins.find(plugin => plugin.id === id);
  }

  get activePluginsCount(): number {
    return this.activePlugins.length;
  }
}